import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ToasterHelper } from '../helpers/toaster.helper';
import { IErrorToSkip } from '../interfaces/error-skip.interface';
import { IValidationError } from '../interfaces/validation-error.interface';

const errorsToSkip: IErrorToSkip[] = [{ status: 401 }, { status: 400, message: 'Invalid token.' }];

export const errorsInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const messageService = inject(MessageService);

  return next(req).pipe(
    tap({
      error: (error: unknown) => {
        if (error instanceof HttpErrorResponse) {
          const shouldSkip = errorsToSkip.some(
            (errorToSkip) =>
              error.status === errorToSkip.status &&
              (!errorToSkip.message || (Array.isArray(error.error) && error.error[0] === errorToSkip.message)),
          );

          if (shouldSkip) {
            return;
          }

          let errorMessage = 'Something went wrong. Please try again later.';

          if (error.error) {
            const validationError = error.error as IValidationError;

            if (validationError.errors) {
              const firstErrorField = Object.values(validationError.errors)[0];
              if (firstErrorField && firstErrorField.length > 0) {
                errorMessage = firstErrorField[0];
              }
            } else if (Array.isArray(error.error)) {
              errorMessage = error.error[0];
            } else if ((error.error as { message: string })?.message) {
              errorMessage = (error.error as { message: string }).message;
            }
          }

          messageService.add(ToasterHelper.errorMessage(errorMessage));
        }
      },
    }),
  );
};
